var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoworking({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 320,
    viewBox: "30 30 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(32 32)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M70.061 131.432c34.228 0 61.975-28.567 61.975-63.808 0-35.235-27.747-63.802-61.975-63.802S8.08 32.389 8.08 67.624c0 35.24 27.753 63.808 61.981 63.808"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M55.626 28.267C55.626 13.157 43.38.91 28.27.91S.912 13.157.912 28.267s12.247 27.357 27.357 27.357 27.357-12.247 27.357-27.357"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 5.818,
    d: "M55.626 28.267C55.626 13.157 43.38.91 28.27.91S.912 13.157.912 28.267s12.247 27.357 27.357 27.357 27.357-12.247 27.357-27.357z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M180.413 121.181c-34.228 0-61.975 28.568-61.975 63.803 0 35.24 27.747 63.808 61.975 63.808 34.235 0 61.981-28.568 61.981-63.808 0-35.235-27.746-63.803-61.98-63.803"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M194.85 224.344c0 15.11 12.248 27.362 27.358 27.362 15.11 0 27.357-12.253 27.357-27.362 0-15.11-12.247-27.358-27.357-27.358s-27.357 12.248-27.357 27.358"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 5.818,
    d: "M194.85 224.344c0 15.11 12.248 27.362 27.358 27.362 15.11 0 27.357-12.253 27.357-27.362 0-15.11-12.247-27.358-27.357-27.358s-27.357 12.248-27.357 27.358z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M219.703 127.346c0 51.526-41.78 93.3-93.306 93.3-51.532 0-93.3-41.774-93.3-93.3 0-51.531 41.768-93.306 93.3-93.306 51.526 0 93.306 41.775 93.306 93.306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 128.003C218 179.36 176.355 221 124.997 221 73.633 221 32 179.361 32 128.003 32 76.639 73.633 35 124.997 35 176.355 35 218 76.639 218 128.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46.013 94.915c10.915 17.373 14.76 34.6 8.587 38.481-6.173 3.875-20.026-7.069-30.94-24.442C12.743 91.58 8.903 74.347 15.077 70.472c6.167-3.874 20.02 7.07 30.935 24.443M204.465 157.699c-10.915-17.373-14.761-34.607-8.588-38.482s20.026 7.07 30.941 24.442c10.915 17.373 14.755 34.601 8.582 38.482-6.167 3.875-20.02-7.07-30.935-24.442"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "201.72 160.988 158.724 203.985 139.419 184.68 182.415 141.683"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "177.692 136.96 134.695 179.956 124.577 169.838 167.58 126.842"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "91.697 50.966 48.701 93.962 68.006 113.267 111.002 70.271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "115.726 74.991 72.729 117.994 82.847 128.106 125.843 85.109"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoworking);
export default __webpack_public_path__ + "static/media/coworking.0f3a7950.svg";
export { ForwardRef as ReactComponent };